/* eslint-disable react-hooks/exhaustive-deps */
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
import { useMemo } from "react";

const STATUS_COLORS: Record<string, string> = {
  compliant: "bg-success",
  rectified: "bg-info",
  non_compliant: "bg-danger",
  not_applicable: "bg-warning text-dark",
  no_audit: "bg-primary",
};

const Legend = () => (
  <div className="d-flex flex-wrap gap-2 mb-3">
    <span className="badge bg-success">Compliant</span>
    <span className="badge bg-info">Rectified late</span>
    <span className="badge bg-danger">Non compliant</span>
    <span className="badge bg-warning text-dark">Not Applicable</span>
    <span className="badge bg-primary">No Audit</span>
  </div>
);

const SummaryCell = ({ data }: any) => {
  return (
    <div className="d-flex flex-wrap gap-1">
      {data.map((item: any, index: number) => (
        <span
          key={index}
          className={`badge ${STATUS_COLORS[item.status]}`}
          style={{ minWidth: "55px", textAlign: "center" }}
        >
          {item.label}
        </span>
      ))}
    </div>
  );
};

const MISTaskHistoryList: React.FunctionComponent = (props: any) => {
  const data = useMemo(
    () => [
      {
        name: "Contract Labour Licence",
        act: "CLRA",
        summary: Array(12).fill({
          label: "Nov-21",
          status: "not_applicable",
        }),
      },
      {
        name: "Commencement / completion of Contract",
        act: "CLRA",
        summary: Array(12).fill({
          label: "Nov-21",
          status: "not_applicable",
        }),
      },
      {
        name: "Manual / Bio-metric time IN and OUT record",
        act: "In Out",
        summary: Array(12).fill({
          label: "Nov-21",
          status: "non_compliant",
        }),
      },
      {
        name: "Attendance / Muster Roll",
        act: "CLRA",
        summary: Array(12).fill({
          label: "Nov-21",
          status: "compliant",
        }),
      },
      {
        name: "Weekly rest day",
        act: "MW",
        summary: Array(12).fill({
          label: "Nov-21",
          status: "compliant",
        }),
      },
    ],
    [],
  );

  return (
    <DashboardLayout
      permissions={getValue(props, "tabPermissionList", [])}
      subTabPermissionList={getValue(props, "subTabPermissionList", [])}
    >
      <div className="dashboard-wrapper__header d-flex align-items-center">
        <div className="d-flex align-items-center">
          <div className="header-parent-icon-holder">
            <NavLink to={`/audit/mis-reports`}>
              <img
                src="/images/back-link.svg"
                className="img-fluid ml-5"
                height={24}
                width={24}
                alt=""
              />
            </NavLink>
          </div>

          <div className="title-wrapper ms-2">
            <h4 className="fw-bold mb-0">Audit History and Open Items</h4>
            <p className="mb-0 text-muted">
              <strong>Site:</strong> Black Rock | <strong>Vendor:</strong>{" "}
              S.K.Facility Management Service Pvt Ltd
            </p>
          </div>
        </div>
      </div>

      <div className="card mt-3 shadow-sm border">
        <div className="card-body">
          <Legend />

          <div className="table-responsive">
            <table className="table table-bordered align-middle ">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "30%" }}>Audit Requirement</th>
                  <th style={{ width: "10%" }}>Act</th>
                  <th>Summary</th>
                </tr>
              </thead>

              <tbody>
                {data.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {index + 1}) {row.name}
                    </td>
                    <td>{row.act}</td>
                    <td>
                      <SummaryCell data={row.summary} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default MISTaskHistoryList;
